import { render, staticRenderFns } from "./CashCollection.vue?vue&type=template&id=8769847e"
import script from "./CashCollection.vue?vue&type=script&lang=js"
export * from "./CashCollection.vue?vue&type=script&lang=js"
import style0 from "./CashCollection.vue?vue&type=style&index=0&id=8769847e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports